/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDeckIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-deck"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.68 21.13L10.68 9.2L2.95 9.2Q2.45 9.2 2.3 8.74Q2.15 8.28 2.55 8L11.22 1.88Q11.57 1.63 12 1.63Q12.43 1.63 12.78 1.88L21.45 8Q21.85 8.28 21.7 8.74Q21.55 9.2 21.05 9.2L13.32 9.2L13.32 21.13Q13.32 21.68 12.94 22.06Q12.55 22.45 12 22.45Q11.45 22.45 11.06 22.06Q10.68 21.68 10.68 21.13ZM2.5 21.13L2.5 16.8L1.88 13.35Q1.77 12.8 2.09 12.36Q2.4 11.93 2.95 11.82Q3.5 11.72 3.94 12.04Q4.38 12.35 4.47 12.88L5 15.7L7.92 15.7Q8.47 15.7 8.86 16.09Q9.25 16.48 9.25 17.02L9.25 21.13Q9.25 21.68 8.86 22.06Q8.47 22.45 7.92 22.45Q7.38 22.45 6.99 22.06Q6.6 21.68 6.6 21.13L6.6 18.35L5.15 18.35L5.15 21.13Q5.15 21.68 4.76 22.06Q4.38 22.45 3.83 22.45Q3.27 22.45 2.89 22.06Q2.5 21.68 2.5 21.13ZM14.75 21.13L14.75 17.02Q14.75 16.48 15.14 16.09Q15.53 15.7 16.07 15.7L19 15.7L19.52 12.88Q19.63 12.35 20.06 12.04Q20.5 11.72 21.05 11.82Q21.6 11.93 21.91 12.36Q22.23 12.8 22.13 13.35L21.5 16.8L21.5 21.13Q21.5 21.68 21.11 22.06Q20.73 22.45 20.18 22.45Q19.63 22.45 19.24 22.06Q18.85 21.68 18.85 21.13L18.85 18.35L17.4 18.35L17.4 21.13Q17.4 21.68 17.01 22.06Q16.63 22.45 16.07 22.45Q15.53 22.45 15.14 22.06Q14.75 21.68 14.75 21.13Z" fill={color} />
    </svg>
  );
}
